//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/plus.svg';
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/minus.svg';
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/chevron-down.svg';
export default {
  name: 'Accordion',
  props: {
    title: {
      type: String,
      required: true
    },
    subtitle: {
      type: String,
      default: null
    },
    url: {
      type: String,
      required: true
    },
    withChevronIcon: {
      type: Boolean,
      default: false
    },
    forceToggleFold: {
      type: Boolean,
      default: false
    },
    externalFold: {
      type: Boolean,
      default: false
    },
    titleCenter: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      isFolded: true
    };
  },

  computed: {
    toggleCondition() {
      return !this.isFolded || this.externalFold;
    }

  },
  methods: {
    toggleFold() {
      if (!this.forceToggleFold) {
        this.isFolded = !this.isFolded;
      }
    }

  }
};